import { render, staticRenderFns } from "./UpdateShop.vue?vue&type=template&id=0b42c9db&scoped=true&"
import script from "./UpdateShop.vue?vue&type=script&lang=js&"
export * from "./UpdateShop.vue?vue&type=script&lang=js&"
import style0 from "./UpdateShop.vue?vue&type=style&index=0&id=0b42c9db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b42c9db",
  null
  
)

export default component.exports